'use strict';

exports.__esModule = true;

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

exports.default = hasValues;

var _extractPropertyFromState = require('./extractPropertyFromState');

var _extractPropertyFromState2 = _interopRequireDefault(_extractPropertyFromState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasValues(state, name) {
  var errors = (0, _values2.default)((0, _extractPropertyFromState2.default)(state, name, 'value'));

  return errors.filter(function (v) {
    return v !== undefined && v !== null;
  }).length > 0;
}
module.exports = exports['default'];